import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  DialogContentText,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const ClearConfirmDialog = ({ open, setOpen, onConfirm }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    // navigate("/assign-course"); // 🔁 redirect on cross
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        Confirm Clear
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center" }}>
        <img
          src="/images/queMark.png"
          alt="warning"
          width={60}
          style={{ marginBottom: 16 }}
        />
        <DialogContentText>
          Are you sure you want to clear all entered data?
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <button className="btn" onClick={onConfirm}>
          Yes, Clear
        </button>
        <button className="btn-negative" onClick={handleClose}>
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearConfirmDialog;
